import React from "react";
import styled from "styled-components";

const G = styled.g`
  stroke: ${props => props.theme.primary};
`;

const HomeSearchIcon = ({ ...props }) => {
  if (window.innerWidth > 1800)
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="23.35"
        height="23.349"
        viewBox="0 0 23.35 23.349"
      >
        <G
          transform="translate(-.25 -.25)"
          fill="none"
          strokeMiterlimit="10"
          strokeWidth="1.5"
        >
          <rect
            width="10.924"
            height="21.849"
            transform="translate(11.924 1)"
          />
          <rect width="10.924" height="14.566" transform="translate(1 8.283)" />
          <line x2="5.098" transform="translate(15.202 10.104)" />
          <line x2="5.098" transform="translate(4.277 13.745)" />
          <line x2="5.098" transform="translate(4.277 18.843)" />
          <line x2="5.098" transform="translate(15.202 5.006)" />
          <line x2="5.098" transform="translate(15.202 15.202)" />
        </G>
      </svg>
    );
  else
    return (
      <svg
        {...props}
        xmlns="http://www.w3.org/2000/svg"
        width="16"
        height="16"
        viewBox="0 0 16 16"
      >
        <G
          transform="translate(.5 .5)"
          fill="none"
          stroke="#455ee5"
          strokeMiterlimit="10"
        >
          <rect width="7.5" height="15" transform="translate(7.5)" />
          <rect width="7.5" height="10" transform="translate(0 5)" />
          <line x2="3.5" transform="translate(9.75 6.25)" />
          <line x2="3.5" transform="translate(2.25 8.75)" />
          <line x2="3.5" transform="translate(2.25 12.25)" />
          <line x2="3.5" transform="translate(9.75 2.75)" />
          <line x2="3.5" transform="translate(9.75 9.75)" />
        </G>
      </svg>
    );
};

export default HomeSearchIcon;
